<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <page-header>Sub Teams</page-header>

            <kiosk-teams-controls
                v-model="fetchParams"
                :sortingEnabled="false"
                @reset="resetFilters"
                @apply="applyFilters"
                :disableCreate="team.status === 'closed'"
            >
            </kiosk-teams-controls>

            <page-loading v-if="loading && !list.length"></page-loading>

            <empty-state v-else-if="!list.length && !isEqual(defaultFilters(), fetchParams)" @reset="resetFilters" />

            <div v-else-if="list.length">
                <kiosk-teams-table>
                    <kiosk-team-row
                        v-for="(row, index) in list"
                        v-model="list[index]"
                        :key="row.id"
                        :disableImpersonation="team.status === 'closed'"
                    ></kiosk-team-row>
                </kiosk-teams-table>

                <div class="mt-8 flex justify-between w-full gap-10">
                    <vx-button
                        v-if="fetchParams.cursor"
                        @click="loadData()"
                        color="muted-dark"
                        size="xl"
                        class="grow-0"
                        data-test="load-more-btn"
                        :loading="loading"
                    >
                        Load More
                        <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                    </vx-button>
                </div>
            </div>

            <empty-state v-else> No sub teams yet. </empty-state>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import EmptyState from '~/components/general/EmptyState.vue';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { VxButton } from '@voxie/frontend-components';
import KioskTeamRow from '../list/KioskTeamRow.vue';
import KioskTeamsControls from '../list/KioskTeamsControls.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import KioskTeamsTable from '../list/KioskTeamsTable.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { adminTeamsClient } from '~/services';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { isEqual } from '~/utils/helpers';
import { useTeamDetails } from '../composables/useTeamDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team } = useTeamDetails();

const defaultFilters = () => ({
    query: '',
    cursor: null,
});

const { loading, list, fetchParams, fetchRecords } = useCursorPagination();

const resetFilters = () => {
    fetchParams.value = defaultFilters();
    loadData();
};

const applyFilters = () => {
    fetchParams.value = {
        ...fetchParams.value,
        cursor: null,
    };

    loadData();
};

const loadData = () => {
    fetchRecords(adminTeamsClient.listSubTeams(props.teamId, fetchParams.value));
};

resetFilters();
</script>
